export default "__VITE_ASSET__7zwQfFH8__"